import { realBricksApi } from '../../utils/axiosInterceptors';

export const cancelOrder = async (data, { rejectWithValue }) => {
  const { id, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.put(`/api/v1/portfolio/cancel-open-order/${id}`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const editOrder = async (data, { rejectWithValue }) => {
    const { id, formData, onFail = () => {}, onSuccess = () => {} } = data;
    try {
      const response = await realBricksApi.put(`/api/v1/portfolio/open-order/${id}`, formData);
      onSuccess();
      return response.data;
    } catch (err) {
      onFail();
      return rejectWithValue(err?.response?.data?.message);
    }
  };

